import { styled, css } from 'styled-components';

import { colors, cssBreakpoints, transition } from '#/theme/theme';

export const TabsContainer = styled.div<{
  $layout: 'vertical-on-desktop' | 'horizontal' | 'full-width-mobile';
}>`
  overflow: hidden;
  position: relative;

  & > button {
    flex-shrink: 0;
  }

  @media all and (max-width: ${cssBreakpoints.xsDown}) {
    display: flex;
    width: ${(props) =>
      props.$layout === 'full-width-mobile'
        ? 'calc(100vw - 2 * var(--cms-body-holder-gutter-width))'
        : 'auto'};

    background-color: ${(props) =>
      props.$layout === 'full-width-mobile' ? colors.softBlue : 'auto'};
    border-radius: ${(props) =>
      props.$layout === 'full-width-mobile' ? '50px' : 'auto'};
    align-items: center;
  }
`;

export const TabsUl = styled.ul<{
  $layout: 'vertical-on-desktop' | 'horizontal' | 'full-width-mobile';
  $variant: 'background' | 'marker' | 'compact-marker';
}>`
  display: ${(props) =>
    props.$layout === 'vertical-on-desktop' ? 'inline-flex' : 'flex'};
  flex-direction: ${(props) =>
    props.$layout === 'vertical-on-desktop' ? 'column' : 'row'};
  overflow: auto;
  gap: ${(props) => (props.$variant === 'background' ? 18 : 20)}px;
  padding: 0;
  margin: 0;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    display: flex;
    flex-direction: row;
  }

  ${(props) =>
    props.$layout === 'full-width-mobile' &&
    css`
      @media all and (max-width: ${cssBreakpoints.xsDown}) {
        container-type: inline-size;
        overflow: scroll;
        width: 100%;

        li {
          width: 100%;
        }

        button {
          display: block;
          line-height: 13px;
          overflow: hidden;
          padding-top: 16px;
          text-align: center;
          text-overflow: ellipsis;
          vertical-align: middle;
          width: 100cqw;
        }
      }
    `}
`;

export const TabsMarker = styled.div`
  position: absolute;
  overflow: hidden;
  height: 2px;
  transform: translateY(-100%);
  background: ${colors.brandBlue};
  transition: ${transition};
  z-index: 2;
`;

export const ArrowButtonContainer = styled.div`
  padding: 8px;

  @media all and (min-width: ${cssBreakpoints.xsUp}) {
    display: none;
  }
`;
